var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      class: ["md-ripple", _vm.rippleClasses],
      on: {
        "&touchstart": function ($event) {
          return ((event) =>
            _vm.mdEventTrigger && _vm.touchStartCheck(event)).apply(
            null,
            arguments
          )
        },
        "&touchmove": function ($event) {
          return ((event) =>
            _vm.mdEventTrigger && _vm.touchMoveCheck(event)).apply(
            null,
            arguments
          )
        },
        "&mousedown": function ($event) {
          return ((event) =>
            _vm.mdEventTrigger && _vm.startRipple(event)).apply(null, arguments)
        },
      },
    },
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm._l(_vm.ripples, function (ripple) {
        return !_vm.isDisabled
          ? _c("md-wave", {
              key: ripple.uuid,
              class: ["md-ripple-wave", _vm.waveClasses],
              style: ripple.waveStyles,
              on: {
                "md-end": function ($event) {
                  return _vm.clearWave(ripple.uuid)
                },
              },
            })
          : _vm._e()
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }